<div class="app-home-banner">
    <div class="app-banner-backdrop">
    </div>

    <div class="align-items-center app-banner-content d-flex justify-content-center">
        <header class="text-center text-white w-75">
            <h1 class="display-2">
                Submit a Request
            </h1>
            <p class="display-6">
                Please select one of the options below to submit a request for your case.
            </p>
        </header>
    </div>
</div>

<div class="mt-4">
    <div class="container">
        <div class="row z-1 app-request-types">
            <div *ngFor="let requestType of requestTypes" class="col-md-4 col-sm-6 mb-4">
                <a [routerLink]="['requests', requestType.reportType, 'create']">
                    <div
                         class="bg-white border p-4 rounded text-center h-100 shadow app-request-option d-flex justify-content-between flex-column">
                        <div>
                            <h2>
                                {{requestType.title}}
                            </h2>
                            <ng-container [ngSwitch]="requestType.reportType">
                                <p *ngSwitchCase="reportType.ComprehensiveCaseReview">
                                    Thorough analysis of medical bills and records to determine if charges are Usual, Customary, and Reasonable (UCR).<br><br>
                                    <strong>Turnaround:</strong> 30 days<br>
                                    <strong>Retainer Amount:</strong> Starting at $1,500<br><br>
                                    Includes detailed expert reporting. Billed at hourly research and administrative rates.
                                </p>

                                <p *ngSwitchCase="reportType.CausationNecessityReasonableness">
                                    Evaluation of causation, medical necessity, and charge reasonableness by licensed physicians.<br><br>
                                    <strong>Turnaround:</strong> 45 days<br>
                                    <strong>Retainer Amount:</strong> Starting at $5,000<br><br>
                                    Expert witness report prepared by medical doctors with specialized experience.
                                </p>

                                <p *ngSwitchCase="reportType.BasicUCR">
                                    Fast database analysis of UCR charges for specified procedures with CPT codes.<br><br>
                                    <strong>Turnaround:</strong> 7 days<br>
                                    <strong>Price:</strong> $295 per provider<br><br>
                                    Ideal for pre-litigation case evaluation and settlement negotiations.
                                </p>

                                <p *ngSwitchCase="reportType.BasicMedicare">
                                    Research-based report detailing Medicare reimbursement rates for services rendered.<br><br>
                                    <strong>Turnaround:</strong> 7–14 days<br>
                                    <strong>Price:</strong> $295 per provider<br><br>
                                    Useful for evaluating government payer benchmarks.
                                </p>

                                <p *ngSwitchCase="reportType.BillingSummary">
                                    Concise summary of total charges, payments, adjustments, and balances from medical billing records.<br><br>
                                    <strong>Turnaround:</strong> 1 week<br>
                                    <strong>Price:</strong> $99 for up to 10 providers (+$10 per additional provider)<br><br>
                                    Helps quickly assess damages in early-stage litigation or mediation.
                                </p>

                                <p *ngSwitchCase="reportType.MedicalChronology">
                                    Chronological outline of a patient’s treatment timeline based on medical records.<br><br>
                                    <strong>Turnaround:</strong> 14–30 days<br>
                                    <strong>Price:</strong> $35/hour (typical project: 5–15 hours)<br><br>
                                    Delivered as an easy-to-reference Excel summary.
                                </p>

                                <p *ngSwitchCase="reportType.BasicCombo">
                                    Comprehensive view combining UCR charges and Medicare rates into a single report.<br><br>
                                    <strong>Turnaround:</strong> 14–30 days<br>
                                    <strong>Price:</strong> $500<br><br>
                                    Supports comparative valuations for damages analysis.
                                </p>

                                <p *ngSwitchCase="reportType.MedicalCostProjection">
                                    Estimation of future medical costs based on treatment plans, fee schedules, and payer reimbursements.<br><br>
                                    <strong>Turnaround:</strong> 30 days<br>
                                    <strong>Price:</strong> Starting from $1,000+ (depending on complexity)<br><br>
                                    Provides detailed projections for anticipated medical expenses, helping evaluate future damages and settlement needs.<br>
                                    Incorporates UCR rates, Medicare benchmarks, and insurance reimbursement data where applicable.<br>
                                    Tailored for cases involving ongoing care, surgeries, therapy, or lifetime medical needs.
                                </p>

                                <p *ngSwitchCase="reportType.OpposingExpertReportReview">
                                    Critical review of opposing expert reports to identify methodological weaknesses and qualification gaps.<br><br>
                                    <strong>Turnaround:</strong> 3–8 hours of review time<br>
                                    <strong>Price:</strong> Billed at expert hourly rates<br><br>
                                    Available as a standalone service or alongside a Comprehensive Case Review.
                                </p>
                                
                            </ng-container>
                        </div>
                        <div>
                            <a class="btn btn-primary w-75"
                               [routerLink]="['requests', requestType.reportType, 'create']">
                                Select
                            </a>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <div class="bg-secondary text-center p-4 text-white">
        <div class="container">
            <h2 class="text-primary mb-5 mt-4">Our Methodology</h2>

            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sit amet nibh sit amet arcu suscipit
                suscipit
                eu
                vel magna. Aliquam erat volutpat. Nunc tincidunt malesuada efficitur. Curabitur vehicula euismod
                orci,
                eu
                sollicitudin sapien blandit a. Nulla porta porta bibendum. Morbi id nisl molestie, interdum augue
                non,
                laoreet
                sem. Nunc facilisis magna ut mattis fringilla. Sed blandit a nisi in pellentesque. Donec non
                ultrices
                risus.
            </p>

            <p>
                Nam a nisi sed lorem hendrerit interdum. Nullam at finibus erat. Maecenas pulvinar pharetra enim,
                sit
                amet
                facilisis diam ornare at. Donec est arcu, semper eu efficitur vitae, porttitor sed ex. Donec sed
                sagittis
                odio.
                Donec id nulla non nibh rhoncus convallis vitae vitae turpis. Vivamus non sem enim.
            </p>

            <p>
                In suscipit lacinia enim, gravida accumsan mi porttitor at. Nullam sed pretium augue. Sed vitae
                felis
                arcu.
                Fusce ornare, sapien non imperdiet vehicula, diam tortor auctor diam, at pellentesque ex dolor ac
                nisl.
                Pellentesque laoreet lobortis nunc eget finibus. Nam eu commodo est. Curabitur at libero et nulla
                fringilla
                pellentesque vulputate eu ante. Nam vel lectus augue.
            </p>
        </div>
    </div>

    <div class="container p-4">
        <div class="row">
            <div class="col-md-4 mb-4 justify-content-center col-md-4 d-flex flex-column app-million-procedures">
                <h2 class="text-primary">
                    Over 1 Million+
                </h2>
                <p class="h4">
                    MEDICAL PROCEDURES REVIEWED
                </p>
                <p>
                    From Emergency Rooms, Physical Therapy, Imaging, Pain Management, Anesthesiologists and Surgical
                    Centers, we’ve reviewed charges from all practice types.
                </p>
            </div>

            <div class="col-md-8 mb-4">
                <img src="/images/125-Blue.png" class="img-fluid" alt="125 years of combined experience" />

                <p class="h4 text-center">
                    YEARS OF COMBINED EXPERIENCE
                </p>
            </div>
        </div>
    </div>
</div>